/**
 * api.config.js
 * Zentrale Konfiguration für alle API-URLs (Laravel Backend)
 */

import { API_URL as ENV_API_URL, IS_DEVELOPMENT } from '@/utils/environmentConfig';

export const getRestaurantSettingsUrl = (restaurantSlug) => {
  const base = ENV_API_URL;
  if (!restaurantSlug) {
    return `${base}/RestaurantSettings`;
  }
  return `${base}/restaurants/${restaurantSlug}/RestaurantSettings`;
};

export const isDevelopment = IS_DEVELOPMENT;

// Reverb/Pusher WebSocket-Konfiguration für Laravel Broadcasting
export const REVERB_CONFIG = {
  key: process.env.VUE_APP_REVERB_APP_KEY || 'table-order-key',
  host: process.env.VUE_APP_REVERB_HOST || 'localhost',
  port: parseInt(process.env.VUE_APP_REVERB_PORT || '8080'),
  scheme: process.env.VUE_APP_REVERB_SCHEME || 'http',
};

// Legacy exports for backward compatibility
export const KITCHEN_HUB_HTTP_URL = null;
export const ORDER_HUB_HTTP_URL = null;

export default {
  KITCHEN_HUB_HTTP_URL,
  ORDER_HUB_HTTP_URL,
  getRestaurantSettingsUrl,
  isDevelopment,
  REVERB_CONFIG
};
